import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BroadcastService {
  private broadcastChannel: BroadcastChannel;
  private keys = [
    'accessToken',
    'refreshToken',
    'accessTokenLastUpdatedAt',
    'requestId',
    'expiresIn',
  ];

  constructor() {
    this.broadcastChannel = new BroadcastChannel('dataChannel');
    this.broadcastChannel.addEventListener(
      'message',
      this.handleRequest.bind(this)
    );
  }

  requestData(): Observable<any> {
    const requestId =
      'dataRequest-' + Math.random().toString(36).substring(2, 9); // Generate unique request ID
    const responseSubject = new Subject<any>();

    // Listen for response to this request
    const responseHandler = (event: MessageEvent) => {
      if (event.data.requestId === requestId) {
        responseSubject.next(event.data.response);
        console.log('response ' + event.data.response);
        responseSubject.complete();
        this.broadcastChannel.removeEventListener('message', responseHandler);
      }
    };
    this.broadcastChannel.addEventListener('message', responseHandler);

    // Send request
    this.broadcastChannel.postMessage({
      action: 'request',
      requestId: requestId,
    });

    return responseSubject.asObservable();
  }

  handleRequest(message: MessageEvent) {
    const data = message.data;
    switch (data.action) {
      case 'set':
        sessionStorage.setItem(data.key, data.value);
        return;
      case 'remove':
        sessionStorage.removeItem(data.key);
        return;
      case 'request':
        // heart beat request
        const requestId = data.requestId;
        console.log('requestId');
        const responseData = 'Response to ' + requestId;
        this.broadcastChannel.postMessage({
          action: 'response',
          requestId: requestId,
          response: responseData,
        });
        return;
      case 'requestOldData':
        let j = 0;
        for (let i = 0; i < sessionStorage.length; i++) {
          const key = sessionStorage.key(i);
          // Retrieve the value for each key add key includes
          if (key != null && this.keys.includes(key)) {
            const value = sessionStorage.getItem(key);
            const status = j + 1 == this.keys.length;
            console.log('sending data...' + key);
            this.broadcastChannel.postMessage({
              action: 'requestedData',
              key: key,
              value: value,
              status: status,
            });
            j++;
          }
        }
        return;
    }
  }

  requestStoredData(): Observable<any> {
    const responseSubject = new Subject<any>();

    // Listen for response to this request
    const responseHandler = (event: MessageEvent) => {
      console.log(event.data);
      if (event.data.action === 'requestedData') {
        const data = event.data;
        sessionStorage.setItem(data.key, data.value);
        if (data.status) {
          responseSubject.next(data.key);
          responseSubject.complete();
          this.broadcastChannel.removeEventListener('message', responseHandler);
        }
      }
    };
    this.broadcastChannel.addEventListener('message', responseHandler);

    // Send request
    this.broadcastChannel.postMessage({ action: 'requestOldData' });

    return responseSubject.asObservable();
  }

  // Set item in session storage and broadcast the change
  setItem(key: string, value: any): void {
    sessionStorage.setItem(key, value);
    this.broadcastChannel.postMessage({
      action: 'set',
      key: key,
      value: value,
    });
    //console.log(this.getItem(key))
  }

  // Get item from session storage
  getItem(key: string): any {
    return sessionStorage.getItem(key);
  }

  // Remove item from session storage and broadcast the change
  removeItem(key: string): void {
    sessionStorage.removeItem(key);
    this.broadcastChannel.postMessage({ action: 'remove', key: key });
  }
}
